import { render, staticRenderFns } from "./loading5.vue?vue&type=template&id=371b4162&scoped=true&"
import script from "./loading5.vue?vue&type=script&lang=js&"
export * from "./loading5.vue?vue&type=script&lang=js&"
import style0 from "./loading5.scss?vue&type=style&index=0&id=371b4162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b4162",
  null
  
)

export default component.exports